import React, { useEffect, useState } from "react";
import styles from "./login.module.scss";

import { JSEncrypt } from "jsencrypt";

import { useForm } from "react-hook-form";
import useAuth, {
  generateRandomUUID,
  getAesEncryptedData,
  getRsaEncryptedData,
} from "../../hooks/useAuth";

import { useDispatch } from "react-redux";
import { setFormFields, clearAuth } from "../../store/features/authSlice";

import { Button } from "../../components/ui/buttons/Button";
import { Link, useNavigate } from "react-router-dom";
import { useToggle } from "../../hooks/useToggle";
import LoginContent from "../../components/common/LoginContent";

// assets
import BrandLogoDark from "../../static/icons/moxey-logo-dark.png";
import { Eye, EyeOff, Mail, PhoneCall } from "react-feather";
import { ROUTES } from "../../routes";

function Login() {
  const dispatch = useDispatch();

  // redirect the user to dashboard if already logged-in else clear the auth
  useEffect(() => {
    dispatch(clearAuth());
  }, [dispatch]);

  return (
    <>
      <div className={styles.app_login_wrapper}>
        <LoginForm />
        <div className={styles.content}>
          <LoginContent />
        </div>
      </div>
    </>
  );
}

export const LoginForm = () => {
  const auth = useAuth();
  const navigate = useNavigate();

  const dispatch = useDispatch();
  const [loading, setloading] = useState(false);
  const { isToggle, handleToggle } = useToggle();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  // verify and send OTP
  const verifyAndSendOTP = (formData) => {
    setloading(true);
    const { username, password } = formData;

    dispatch(setFormFields({ userName: username }));

    // generate random salt for user encryption
    const randomUUID = generateRandomUUID();
    const EncryptedUsername = getAesEncryptedData(username, randomUUID);
    const EncryptedPassword = getAesEncryptedData(password, randomUUID);

    const aesKeyEncryptedUsingPublicKey = getRsaEncryptedData(
      randomUUID,
      JSEncrypt
    );

    // Asking to send the OTP
    auth
      .sendOTP({
        userName: EncryptedUsername,
        password: EncryptedPassword,
        aesKeyEncryptedUsingPublicKey,
        resendOtp: false,
      })
      .then((res) => {
        if (res.status === 200) navigate(ROUTES.VERIFY_OTP);
        setloading(false);
      })
      .catch((error) => {
        setloading(false);
        if (error.status === 401) navigate(ROUTES.LOGIN);
      });
  };
  return (
    <form
      className={styles.app_login_form}
      onSubmit={handleSubmit(verifyAndSendOTP)}
    >
      {/* moxey brand logo */}
      <div className="text-center">
        <MoxeyBrandLogo />
        <h5 className="text-dark my-5">Sign In</h5>
      </div>
      <label
        htmlFor="input-username"
        className="form-label text-start required"
      >
        Username
      </label>
      <div className="mb-3">
        <input
          id="input-username"
          {...register("username", {
            required: {
              value: true,
              message: "Please Enter Username",
            },
          })}
          className={`form-control form-control-lg ${
            errors.username ? "is-invalid" : ""
          }`}
          placeholder="Username"
          type="text"
        />
        <div className="invalid-feedback text-start">
          {errors.username && errors.username.message}
        </div>
      </div>
      <label
        htmlFor="input-paassword"
        className="form-label text-start required"
      >
        Password
      </label>
      <div className="input-group mb-3">
        <input
          id="input-paassword"
          {...register("password", {
            required: {
              value: true,
              message: "Please Enter Password",
            },
          })}
          className={`form-control form-control-lg ${
            errors.password ? "is-invalid" : ""
          }`}
          placeholder="Password"
          type={isToggle ? "text" : "password"}
          autoComplete="off"
        />
        <button
          type="button"
          onClick={handleToggle}
          style={{ cursor: "pointer" }}
          className="input-group-text rounded-end"
        >
          {isToggle ? (
            <Eye size={16} color="grey" />
          ) : (
            <EyeOff size={16} color="grey" />
          )}
        </button>
        <div className="invalid-feedback text-start">
          {errors.password && errors.password.message}
        </div>
      </div>
      <div className="form-group mb-3">
        <Button
          text={"Sign In"}
          loading={loading}
          className="btn btn-lg btn-primary  w-100"
          type="submit"
        />
      </div>

      <div className="form-group mb-3">
        <Link to={ROUTES.FORGOT_PASSWORD} className="btn btn-link w-100">
          Forgot Password
        </Link>
      </div>
    </form>
  );
};

export const MoxeyBrandLogo = () => {
  return (
    <img
      className={styles.app_login_logo}
      src={BrandLogoDark}
      alt="Moxey Brand Logo"
    />
  );
};

export default Login;
